import ActionButton from '../../../../common/components/documentViewer/actionButton';
import { IActionButtonCommonProps } from '../../../../common/typings/DocumentViewer/actionButtonCommonProps';
import { getScaledViewport } from '../../../../common/utils/viewportHelper';
import { IOrderViewerMainStore } from '../../typing/stores';
import { Icons } from 'copyright-clearance-center-common-ui';
import { inject } from 'mobx-react';

interface IPopOutButton {
	deliveryLink?: string;
}

const PopOutButton: React.FunctionComponent<IPopOutButton & IActionButtonCommonProps> = props => {
	const handler = () => {
		const viewport = getScaledViewport(0.8);
		const features = `Width=${viewport.width},Height=${viewport.height},menubar=no,resizable=yes,status=no,toolbar=no,scrollbars=yes`;
		window.open(props.deliveryLink, '_blank', features);
	};

	return (
		<ActionButton
			label={localize('Pop out')}
			handler={handler}
			icon={Icons.DuplicateIcon}
			isPrimary={props.isPrimary}
			testId="pop-out-btn"
			controlledBy={props.controlledBy}
		/>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	deliveryLink: stores.orderViewerStore.viewModel.documentModel.deliveryLink
}))(PopOutButton);
